import { render, staticRenderFns } from "./ImportedBlocks.vue?vue&type=template&id=2ae7b3b8&scoped=true"
import script from "./ImportedBlocks.vue?vue&type=script&lang=js"
export * from "./ImportedBlocks.vue?vue&type=script&lang=js"
import style0 from "./ImportedBlocks.vue?vue&type=style&index=0&id=2ae7b3b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae7b3b8",
  null
  
)

export default component.exports